import React from 'react';
import { translate } from 'react-i18next';
import { Avatar, Text } from 'wix-style-react';
import moment from 'moment';
import s from './ReplyReview.scss';

const ReplyReview = ({ t, replyDate, replyBody, name, profilePhoto }) => {
  return (
    <div className={s.root} data-hook="reply-review-container">
      <div
        className={s.replyReviewAvatar}
        data-hook="reply-review-avatar-wrapper"
      >
        <Avatar
          color="A1"
          imgProps={{
            src: profilePhoto,
          }}
          name={name}
          size="size48"
        />
      </div>
      <div className={s.replyReviewDetails} data-hook="reply-review-details">
        <Text
          weight="bold"
          size="small"
          secondary={false}
          light={false}
          className={s.replyReviewName}
        >
          {name}
        </Text>
        <Text
          weight="normal"
          size="small"
          secondary={true}
          light={false}
          tagName="div"
          className={s.replyReviewDate}
        >
          {moment(new Date(replyDate)).format(
            t('client-expertview-reviews-date-format'),
          )}
        </Text>
        <Text
          weight="thin"
          size="small"
          secondary={false}
          light={false}
          tagName="div"
          className={s.replyReviewBody}
        >
          {replyBody}
        </Text>
      </div>
    </div>
  );
};

export default translate()(ReplyReview);
